export const KpisTimeOnIceExplanation = () => {
    const dot = (
        <div
            className="w-2 h-2 mt-1 rounded-full shrink-0"
            style={{ backgroundColor: "var(--color-general-purple)" }}
        />
    );

    return (
        <div className="space-y-3">
            <h3 className="text-base font-headline font-bold text-on-surface">
                Time on Ice Impact and Minimum Qualification
            </h3>
            <div className="bg-surface-container rounded-md p-3 sm:p-4 border border-outline-variant/20 space-y-4">
                <div>
                    <div className="flex items-start gap-2">
                        {dot}
                        <p className="text-sm font-medium text-on-surface">
                            To ensure statistical validity and a representative sample size, a player must record a
                            minimum of 300 seconds (5 minutes) of Time on Ice (TOI) to be evaluated by the model.
                        </p>
                    </div>
                </div>

                <div>
                    <div className="flex items-start gap-2 mb-1.5">
                        {dot}
                        <p className="text-sm font-semibold text-on-surface">For players who meet this threshold</p>
                    </div>
                    <p className="text-sm text-on-surface ml-4 sm:ml-5">
                        The KPI is designed to ensure that varying playing times do not disproportionately skew the
                        results. To achieve this balance, the model utilizes a hybrid weighted z-score, which
                        effectively blends raw statistical volume with rate-based production (e.g., volume per 20
                        minutes). This means a player who participated for a relatively short time can still achieve a
                        satisfactory score based on high efficiency. Conversely, for players with heavy ice time—who
                        naturally have more opportunities to make both positive plays and mistakes—the negative impact
                        of errors is proportionally absorbed and balanced by their overall volume of contribution.
                    </p>
                </div>

                <div>
                    <div className="flex items-start gap-2 mb-1.5">
                        {dot}
                        <p className="text-sm font-semibold text-on-surface">Example</p>
                    </div>
                    <p className="text-sm text-on-surface ml-4 sm:ml-5">
                        A player who successfully makes 4 out of 4 passes (100% accuracy) will receive fewer points for
                        this aspect of play than a player who makes 18 out of 20 passes (90% accuracy). The hybrid
                        approach ensures a balanced assessment of both the quality and the sheer volume of a player's
                        performance.
                    </p>
                </div>

                <div>
                    <div className="flex items-start gap-2 mb-1.5">
                        {dot}
                        <p className="text-sm font-semibold text-on-surface">
                            Time-Based Scaling and Contextual Metrics
                        </p>
                    </div>
                    <p className="text-sm text-on-surface ml-4 sm:ml-5">
                        Certain effort-related metrics are explicitly scaled by time units (e.g., per 20 minutes), while
                        others, such as relative Corsi or relative Fenwick, measure the player's contextual impact on
                        the game rather than relying on raw totals.
                    </p>
                </div>
            </div>
        </div>
    );
};
